import { Action, createReducer, on } from '@ngrx/store';

import { LoadingState } from '@core/utility/state';

import {
  fetchIdentityAction,
  fetchIdentityFailedAction,
  fetchIdentitySucceededAction,
} from './identity.actions';
import { IdentityState, initialIdentityState } from './identity.state';

export const identityReducerFn = createReducer(
  initialIdentityState,
  on(fetchIdentityAction, state => ({
    ...state,
    requestState: LoadingState.LOADING,
  })),
  on(fetchIdentitySucceededAction, (state, { account }) => ({
    ...state,
    account,
    requestState: LoadingState.LOADED,
  })),
  on(fetchIdentityFailedAction, (state, { error }) => ({
    ...state,
    requestState: { error },
  })),
);

export const identityReducer = (state: IdentityState = initialIdentityState, action: Action): IdentityState => {
  return identityReducerFn(state, action);
};
